import { render, staticRenderFns } from "./ShopPaypalPaymentView.vue?vue&type=template&id=23d5902e&"
import script from "./ShopPaypalPaymentView.vue?vue&type=script&lang=js&"
export * from "./ShopPaypalPaymentView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports